import React from 'react'
import { Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material'
import { ObservatoryRow } from 'common/types'
import { DenseTableCell } from './DenseTableCell'
import { useGlobalState } from 'state'

type RainMonitorProps = {
  height: string | number
  rains: ObservatoryRow[]
}

export const RainMonitor = ({rains, height}: RainMonitorProps) => {
  const state = useGlobalState()
  const [rows, setRows] = React.useState<ObservatoryRow[]>([])

  React.useEffect(() => {
    const targets = [...rains]
    setRows(targets)
  }, [rains])

  const handleClick = (row: ObservatoryRow) => {
    state.observatory.setSelected(row)
    state.app.setObservatoryContainer(true)
    state.map.setView(row.lng, row.lat, 12)
  }

  return (
    <TableContainer sx={{height: height}}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <DenseTableCell th text="観測所名" left />
            <DenseTableCell th text="現在雨量" />
            <DenseTableCell th text="累加雨量" />
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow key={i}  sx={{ cursor: 'pointer' }} hover onClick={() => handleClick(row)}>
              <DenseTableCell text={row.name} left />
              <DenseTableCell text={row.min10 === undefined ? '-' : row.min10.toFixed(2)} />
              <DenseTableCell text={row.total === undefined ? '-' : row.total.toFixed(2)} />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
